// extracted by mini-css-extract-plugin
export var userSearchResultHeader = "user-search-result-header_GMrgr8idaWvFunxA08Us";
export var userSearchResultHeaderLiveCount = "user-search-result-header__live-count_wwYNf7nJEQsIKH9TC7mx";
export var userSearchResultHeaderSeparator = "user-search-result-header__separator_IbviFLMbUgSjyAzaoSAC";